/**
 * Отправка файлов на почту
 */
class SendFiles {

    /**
     * Расшифровка ошибки
     * @param code
     */
    static errorCode(code = 0) {

        let res = {
            error: true,
            code: code,
            text: '',
        };

        switch (code) {
            case 0:
                res.text = 'Время ответа превышено';
                break;
            case 204:
                res.text = 'Пустой запрос';
                break;
            case 405:
                res.text = 'Программа структура не установлена на вашем компьютере';
                break;
            case 400:
                res.text = 'Неверный запрос';
                break;
            case 200:
                res.text = 'Отправка';
                res.error = false;
                break;
            default:
                res.text = 'Неизвестная ошибка';
        }
        return res;
    }

    /**
     * Base64
     * Учитывает кирилицу
     * @param str
     * @return {string}
     */
    static utf8_to_b64(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }

    /**
     * Отправить файлы
     * @param files
     * @param success
     */
    static send(files, success = () => {}) {
        fetch(this.programmUrl, {
            method: 'POST',
            body: this.utf8_to_b64(JSON.stringify(files))
        }).then((res) => {
            success(this.errorCode(res.status));
        }).catch((e) => {
            success(this.errorCode());
        });
    }
}

SendFiles.programmUrl = 'http://localhost:60064';

export default SendFiles;